var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPdfPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 29.3332C7.29243 29.3332 6.61415 29.0522 6.11406 28.5521C5.61396 28.052 5.33301 27.3738 5.33301 26.6665V5.33317C5.33301 4.62593 5.61396 3.94765 6.11406 3.44756C6.61415 2.94746 7.29243 2.66651 7.99967 2.66651H18.6663C19.0884 2.66582 19.5065 2.74864 19.8964 2.9102C20.2863 3.07176 20.6404 3.30885 20.9383 3.60784L25.7223 8.39184C26.0221 8.68985 26.2599 9.0443 26.4219 9.43472C26.584 9.82515 26.667 10.2438 26.6663 10.6665V26.6665C26.6663 27.3738 26.3854 28.052 25.8853 28.5521C25.3852 29.0522 24.7069 29.3332 23.9997 29.3332H7.99967Z",
    stroke: "#612EF7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 2.6665V9.33317C18.667 9.68679 18.8075 10.0259 19.0575 10.276C19.3076 10.526 19.6467 10.6665 20.0003 10.6665H26.667",
    stroke: "#612EF7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 12H10.667",
    stroke: "#612EF7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 17.3335H10.667",
    stroke: "#612EF7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 22.6665H10.667",
    stroke: "#612EF7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdfPurple);
export default __webpack_public_path__ + "static/media/ic_pdf_purple.485e00ac0fd7ef8f3132770259a3d06e.svg";
export { ForwardRef as ReactComponent };